<template>
  <div class="report-wrap">
    <loading :isFinish="loading" :showRotateTips="showRotateTips"/>
    <div v-if='showRotateTips'>
        <div class="header" v-show='hasData'>
            <div class="logo">
              <div class='logo-img'><img src='@/assets/images/year-review/review-logo@2x.png'/></div>
              <img v-if='showPotrait' :class='["userPic", showPotrait ? "showPic" : ""]' :src="user_portrait_url">
            </div>
            <div class="header-map">
                <div class="left-map">
                  <year-review-map :states="dirverData.state" :tureCountry='tureCountry' :changePotraitState='changePotraitState' :url="user_portrait_url" :showRotateTips="showRotateTips"></year-review-map>
                </div>
                <div class="right-tit">
                  <div class='right-tit-have'>In 2019, you</div>
                  <div class='right-tit-same' v-show="isShowMiles">Planned <b class="report-blue">{{tripsCount}}</b> trips</div>
                  <div class='right-tit-same' v-show="isShowMiles">Travelled <b class="report-blue">{{milesCount}}</b> miles</div>
                  <div class='right-tit-same'>Passed through <b class="report-blue">{{statesCount}}</b> state{{ statesCount > 1 ? "s":""}}</div>
                  <div class='right-tit-same'>Drove further than <b class="report-blue">{{truckerCount}}% </b>of peers</div>
                </div>
            </div>
            <div class="line"></div>
          </div>
    </div>
    <div v-else class="year-report" id="yearReport">
      <header>
        <img class="report-logo" src="@/assets/images/year-review/review-logo@2x.png">
        <img v-if='showPotrait' :class='["userPic", showPotrait ? "showPic" : ""]' :src="user_portrait_url">
      </header>
      <section>
        <year-review-map :states="dirverData.state" :tureCountry='tureCountry' :changePotraitState='changePotraitState' :url="user_portrait_url"></year-review-map>
        <div :class='["report-detail", tureCountry === "Canada" ? "mgTop10" : ""]'>
          <div class="report-detail-have">In 2019, you</div>
          <div  class="report-detail-comm report-detail-with" v-show="isShowMiles">Planned <b class="report-blue">{{tripsCount}}</b> trips</div>
          <div  class="report-detail-comm report-detail-with" v-show="isShowMiles">Travelled <b class="report-blue">{{milesCount}}</b> miles</div>
          <div :class="{'report-detail-comm':true, 'report-detail-trips':true,'report-detail-font18': !isShowMiles}">Passed through <b class="report-blue">{{statesCount}}</b> state{{ statesCount > 1 ? "s":""}}</div>
          <div :class="{'report-detail-comm':true, 'report-detail-trips':true,'report-detail-font18':!isShowMiles}">Drove further than <b class="report-blue">{{truckerCount}}% </b>of peers</div>
        </div>
      </section>
      <footer class="report-explore" @click="goToStatic">
        <img src='@/assets/images/year-review/review-expolre@2x.png'/>
      </footer>
    </div>
  </div>
</template>
<script>
import yearReviewMap from './components/map.vue';
import Base64 from './static/base64.js'
import loading from './components/loading.vue'
import mixpanel from "@/utils/mixpanel.js";

import { getDriverState } from '@/api/yearReview.js'
import {usaData, canadaData } from './static/stateCaculate.js';
export default {
  name:'year-report',
  components:{
    yearReviewMap,
    loading
  },
  props:['goToStatic','toggleSlide', 'changeInitialSlide','handleShowPage', 'getQuery' , 'hidePageOne','showRotateTips'],
  data(){
    return {
      pageUrl: '',
      tripsCount: 0,
      statesCount: 0,
      truckerCount: 0,
      milesCount: 0,
      isInApp: true,
      isShowMiles: false,
      currentValue: false,
      tureCountry: 'USA',
      showPotrait: false,
      loading: false,
      test: 0,
      user_portrait_url: require('@/assets/images/year-review/userPortrait.png'),
      params: {
        distinct_id: '',
        installation_id: '',
        device_id: '',
        internal_user_id: ''
      },
      dirverData:{
        state: []
      },
      hasData:true
    }
  },
  mounted() {
    this.initView()
  },
  methods:{
    changePotraitState(){
      this.showPotrait = true;
    },
    initView(){
      this.getDriverData()
    },
    autoPlusNumber(time,goal,initial,regular,name){
      let count = 0;
      let step = goal / (time/regular);
      goal = name === 'milesCount' ? parseInt(goal.toString().split(",").join("")) : goal;
      let timer = setInterval(() => { 
        count = count + step; 
        if(count >= goal) { 
          clearInterval(timer);
          count = goal; 
        } 
        let t =name === 'milesCount' ? this.showPercent(count): Math.floor(count); 
        // let t = Math.floor(count); 
        if(t == initial) return t; //t未发生改变的话就直接返回 
        this[name] = t
      }, 30); 
    },
    showPercent(parm){
      let temp = parm.toString().split("").reverse();
      let res = [];
      temp.forEach( (item,idx) => {
        if(idx % 3 === 0 && idx !== 0){
          res.push(',');
        }
        res.push(item);
      })
      return res.reverse().join("");
    },
    getDriverData(){
      // debugger
      let cookiestr = document.cookie
      // console.log('coockie', document.cookie)
      this.isInApp = cookiestr.indexOf('driver-token') > -1 || cookiestr.indexOf('distinct-id') > -1 ||  cookiestr.indexOf('installation-id') > -1 || cookiestr.indexOf('device-id') > -1 || cookiestr.indexOf('internal-user-id') > -1
      // console.log(cookiestr,'......cookiestr')
      if(this.isInApp && cookiestr){ // app 内
        let cookieList = cookiestr.split(';')
        // console.log(cookieList,'......cookieList')
        cookieList.forEach(item => {
          let itemArr = item.split('=');
          if(itemArr[0].trim() === 'distinct-id' || itemArr[0].trim() === 'installation-id' || itemArr[0].trim() === 'device-id' || itemArr[0].trim() === 'distinct_id' ) {
            if(itemArr[0].indexOf('-')>-1){
              this.params[itemArr[0].trim().replace(/-/g,'_')] = itemArr[1];
            }else if(itemArr[0].indexOf('_')>-1){
              this.params[itemArr[0].trim()] = itemArr[1];
            }
          }
        })
        Object.keys(this.params).forEach(item=>{
          if(this.params[item] === '' || typeof this.params[item] === 'undefined'){
            delete this.params[item]
          }else{
            this.params[item] = Base64.encode(this.params[item])
          }
          this.getQuery(this.params)
        })
        //埋点
        mixpanel.track('User Growth Campaign', { 'Outcome': 'First page view' ,'Campaign name': '2019 Year in Review','View Type': 'User view'})

      }else{ // app 外
        Object.keys(this.params).forEach(item=>{
          if(this.$route.query[item]){
            this.params[item] = this.$route.query[item]
          }
          if(this.params[item] === '' || typeof this.params[item] === 'undefined'){
            delete this.params[item]
          }
        })
        //埋点
        mixpanel.track('User Growth Campaign', { 'Outcome': 'First page view' ,'Campaign name': '2019 Year in Review','View Type': 'Sharing view'})
      }
      if(Object.keys(this.params).length){
        getDriverState(this.params).then(res=>{ 
        // getDriverState({distinct_id: Base64.encode('13D4C7AD-C111-4440-BF6F-BFEEA015327D')}).then(res=>{   
          if(res.status === 200 && res.data.state_code === 0){
            this.dirverData = res.data.data
            if(res.data.data.image_url){
              this.user_portrait_url = res.data.data.image_url;
            }
            if(this.dirverData.state.length){
              this.$bus.$emit('onlyStatic',{flag: false})
              this.autoPlusNumber(500,this.dirverData.state.length,0,60,'statesCount')
            }else{ // 没有state州时 只展示第二页
              if(this.showRotateTips ){
                this.hasData = false;
              }else{
                // this.hidePageOne({flag: false,reason: '没有state州时 0'})
                if(this.showRotateTips ){
                  this.hasData = false;
                }else{
                  this.hidePageOne({flag: false,reason: '没有state州时 0'})
                }
              }
            }
            const pesent = this.dirverData.exceeding * 100
            this.autoPlusNumber(1500,pesent,10,30,'truckerCount')
            this.autoPlusNumber(1500,Number(this.dirverData.route_time),10,30,'tripsCount')
            this.autoPlusNumber(500,Number(this.dirverData.distance),0,90,'milesCount')
            this.isShowMiles = Number(this.dirverData.distance) >= 40000 && this.dirverData.distance <= 250000;
            this.loading = true
            
            this.getCurrentCountry();
          }else{
            //请求数据有问题时 只展示第二页
            this.loading = true
            // this.hidePageOne({flag: false,reason: '没有state州时 0'})
            if(this.showRotateTips ){
              this.hasData = false;
            }else{
              this.hidePageOne({flag: false,reason: '没有state州时 0'})
            }
          }
        })
      }else{
        // 拿不到参数时只展示第二页
        // this.hidePageOne({flag: false,reason: '没有state州时 0'})
        if(this.showRotateTips ){
          this.hasData = false;
        }else{
          this.hidePageOne({flag: false,reason: '没有state州时 0'})
        }
        this.loading = true
      }
      // console.log(1232)
    },
    getCurrentCountry(){
      let stateObj = {};
      if(this.dirverData.state.length > 0){
        let usaDataStr = usaData.join(' ');
        let canadaDataStr = canadaData.join(' ');
        this.dirverData.state.forEach(ele => {
          if(usaDataStr.indexOf(ele) > -1){
            stateObj['USA'] = true;
          }
          if(canadaDataStr.indexOf(ele) > -1){
            stateObj['Canada'] = true;
          }
        })
      }
      let stateArr = Object.keys(stateObj);
      if(stateArr.length > 1){
        this.tureCountry = 'USACanada';
      }else if(stateArr.length == 1){
        this.tureCountry = stateArr[0];
      }else{
        this.tureCountry = 'USA';
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/rem.scss';

  $rem: 66.7px;
  html{
    font-size: $rem;
  }
  @function remHos($px) {
    @return $px / $rem * 1rem;
  }

  $blue:rgb(3,118,239);
  .line{
    padding:0 rem(25px);
    &:before{
      content: '';
      display: block;
      border-bottom: 1px solid #0030621a;
    }
  }
  .padding25{
    padding: 0 rem(25px);
    box-sizing: border-box;
  }
  .report-wrap{
    width: 100%;
    height:100%;
  }
  .year-report{
    width:100%;
    height:100%;
    display: flex;
    flex-direction: column;
    background: #f6fbfe url('../../assets/images/year-review/review-bg@2x.png') no-repeat center;
    background-size:cover; 
    box-sizing: border-box;
    padding-bottom: rem(76px);
    section{
      flex:1;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
    }
    header{
      flex-shrink: 0;
      display: flex;
      align-items: center;
      width:100%;
      height: rem(44px);
      @extend .padding25;
      margin-bottom: rem(25px);
      .userPic{
        display: none;
        position: absolute;
        right: rem(25px);
        top: rem(10px);
        margin: auto;
        width: rem(37.5px);
        height: rem(37.5px);
        border-radius: 50% 50%;
      }
      .showPic{
        display: block;
      }
    }
  }
  .report-blue{
    color: $blue;
  }
  
  .report-logo{
    height: rem(18px);
  }
  .report-detail{
    color: #141A42;
    font-size: rem(18px);
    font-family: Gotham-Bold;
    @extend .padding25;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex:1;
    :first-child{
      margin-bottom: rem(19px);
      font-size: rem(16px);
      @extend .report-blue;
    }
    .report-detail-comm{
      margin-bottom: rem(19px);
    }
    .report-detail-font18{
      // font-size: rem(18px);
      
    }
  }
  
  .report-explore{
    width: rem(213px); 
    margin: 0 auto rem(8px);
    cursor: pointer;
    animation: openImg 1.5s infinite ease-out;
    img{
      width: 100%;
    }
  }
  .mgTop10{
    margin-top: rem(-10px);
    transform: scale(1);
  }
  @keyframes openImg {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(rem(8px));
    }
    100% {
      transform: translateY(0);
    }
  }

  // iphone x xr 11 的设备比所在区域 
  @media screen and (min-aspect-ratio: 414 / 740) and (max-aspect-ratio: 414 / 700){
  }
  
  @media screen and (min-aspect-ratio: 414 / 700) and (max-aspect-ratio: 414 / 660){
    .report-detail {
      margin-top: rem(-30px)!important;
      transform: scale(0.95);
    }
    // .report-explore{
    //   margin-top: rem(-10px)!important;
    // }
  }

  @media screen and (min-aspect-ratio: 414 / 660) and (max-aspect-ratio: 414 / 620){
    .report-detail {
      margin-top: rem(-35px)!important;
      transform: scale(0.9); 
      :first-child{
        margin-bottom: rem(15px);
      }
      .report-detail-comm{
        margin-bottom: rem(15px);
      }
    }
    // .report-explore{
    //   margin-top: rem(-15px)!important;
    // }
  }
  // iphone 6 7 8 所在区域
  @media screen and (min-aspect-ratio: 414 / 620) and (max-aspect-ratio: 414 / 600){
    .report-detail {
      margin-top: rem(-35px)!important;
      transform: scale(0.9);
      margin-left: rem(-10px); 
      :first-child{
        margin-bottom: rem(12px);
      }
      .report-detail-comm{
        margin-bottom: rem(12px);
      }
    }
    // .report-explore{
    //   margin-top: rem(-15px)!important;
    // }
  }
  
  @media screen and (min-aspect-ratio: 414 / 600) and (max-aspect-ratio: 414 / 580){
    .report-detail {
      margin-top: rem(-40px)!important;
      transform: scale(0.9);
      margin-left: rem(-10px); 
      :first-child{
        margin-bottom: rem(12px);
      }
      .report-detail-comm{
        margin-bottom: rem(12px);
      }
    }
    // .report-explore{
    //   margin-top: rem(-15px)!important;
    // }
  }
  
  @media screen and (min-aspect-ratio: 414 / 580) and (max-aspect-ratio: 414 / 550){
    .report-detail {
      margin-top: rem(-43px)!important;
      transform: scale(0.9);
      margin-left: rem(-10px); 
      :first-child{
        margin-bottom: rem(10px);
      }
      .report-detail-comm{
        margin-bottom: rem(10px);
      }
    }
    // .report-explore{
    //   margin-top: rem(-10px)!important;
    // }
  }
  
  @media screen and (min-aspect-ratio: 414 / 550) and (max-aspect-ratio: 414 / 520){
    .report-detail {
      margin-top: rem(-48px)!important;
      transform: scale(0.85);
      margin-left: rem(-10px); 
      :first-child{
        margin-bottom: rem(8px);
      }
      .report-detail-comm{
        margin-bottom: rem(8px);
      }
    }
    // .report-explore{
    //   margin-top: rem(-15px)!important;
    // }
  }

  // ipad 横屏
  @media screen and (min-aspect-ratio: 414 / 414) and (max-aspect-ratio: 414 / 100){
    .report-detail {
      margin-top: rem(-55px)!important;
      transform: scale(0.85);
      :first-child{
        margin-bottom: rem(7px);
      }
      .report-detail-comm{
        margin-bottom: rem(7px);
      }
    }
    // .report-explore{
    //   margin-top: rem(-15px)!important;
    // }
  }



  .logo{
    width:100%;
    height: remHos(44px);
    padding:0 remHos(25px);
    box-sizing: border;
    position: relative;
    .userPic{
      display: none;
      position: absolute;
      right: remHos(25px);
      // right:0;
      top: remHos(10px);
      margin: auto;
      width: remHos(37.5px);
      height: remHos(37.5px);
      text-align: right;
      border-radius: 50% 50%;
    }
    .showPic{
      display: block;
    }
    .logo-img{
      width:100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        height: remHos(18px);
      }
    }
    
  }
  .header-map{
    width:100%;
    display: flex;
    font-family: Gotham-Bold;
    .left-map{
      width:54%;
      justify-content: center;
      align-self:center;
    }
    .right-tit{
      color:#141A42;
      font-weight: bold;
      font-size:remHos(18px);
      .right-tit-have{
        font-family: Gotham-Book;
        font-size:remHos(16px);
        margin-bottom:remHos(19px);
        margin-top:remHos(16px);
        @extend .report-blue;
      }
      .right-tit-same{
        margin-bottom:remHos(19px);
      }
    }
    }

</style>
